module.exports = [
  {
    id: 1,
    value: 1,
    label: "1-9",
    price: "24.58",
    explanation:
      "This subscription level will allow up to 9 organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "295",
    plan: "1"
  },
  {
    id: 2,
    value: 2,
    label: "10-24",
    price: "41.25",
    explanation:
      "This subscription level will allow between 10 and 24 organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "495",
    plan: "2"
  },
  {
    id: 3,
    value: 3,
    label: "25-49",
    price: "66.25",
    explanation:
      "This subscription level will allow between 25 and 49 organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "795",
    plan: "3"
  },
  {
    id: 4,
    value: 4,
    label: "50-99",
    price: "107.92",
    explanation:
      "This subscription level will allow between 50 and 99 organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "1295",
    plan: "4"
  },
  {
    id: 5,
    value: 5,
    label: "100-249",
    price: "124.59",
    explanation:
      "This subscription level will allow between 100 and 249 organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "1495",
    plan: "5"
  },
  {
    id: 6,
    value: 6,
    label: "250-499",
    price: "199.58",
    explanation:
      "This subscription level will allow between 250 and 499 organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "2395",
    plan: "6"
  },
  {
    id: 7,
    value: 7,
    label: "500-999",
    price: "249.59",
    explanation:
      "This subscription level will allow between 500 and 999 organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "2995",
    plan: "7"
  },
  {
    id: 8,
    value: 8,
    label: "1k-5k",
    price: "291.25",
    explanation:
      "This subscription level will allow between 1k and 5k organization members to create a FirstLine Social account. Organizations will be billed annually.",
    total: "3495",
    plan: "8"
  }
]



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/subOptions.js